import React, { useState, useRef, useEffect } from "react";
import '../../css/templates.css';
import MessageVariables from '../messageVariables';
import { fetchWithDefaults } from '../../config/fetchDefault';
import { useSelector } from 'react-redux';
import Variables from './variables';
import Icon from "../../assets/icons/icon";
import Dropdown from "../../utilities/helperComponents/Dropdown";
import PrimaryButton from "../../utilities/helperComponents/PrimaryButton";
import InputTextField from "../../utilities/helperComponents/InputTextField";
import Toggle from "../../utilities/helperComponents/Toggle";

function LeadTypeScriptTemplate({}){
    const [selectedLeadType, setSelectedLeadType] = useState(null)
    const [leadTypeList, setLeadTypeList] = useState([
        {
            label: 'General Life',
            value: 'GENERAL LIFE',
        },
        {
            label: 'Mortgage Protection',
            value: 'MORTGAGE PROTECTION',
        },
        {
            label: 'Final Expense',
            value: 'FINAL EXPENSE',
        },
    ])

    const [scriptSectionIDs, setScriptSectionIDs] = useState([])
    const [scriptSections, setScriptSections] = useState({})
    const [scriptContentBlocks, setScriptContentBlocks] = useState({})
    const [editSection, setEditSection] = useState({})
    const [editSectionContentBlock, setEditSectionContentBlock] = useState({})

    const [updatedContentBlockData, setUpdatedContentBlockData] = useState({})
    const [updatedScriptSection, setUpdatedScriptSection] = useState(null)
    const [excludeSectionID, setExcludeSectionID] = useState(null)

    const [loading, setLoading] = useState(false)
    const [addContentBlockSectionID, setAddNewContentBlockSectionID] = useState(null)
    const [newContentBlockContentType, setNewContentBlockContentType] = useState(null)
    const [newContentBlockContent, setNewContentBlockContent] = useState(null)
    const [newContentBlockContentOption, setNewContentBlockContentOption] = useState(null)

    const [addNewSection, setAddNewSection] = useState(false)
    const [newSectionName, setNewSectionName] = useState(null)

    const getSectionsForTenantLeadType = async (leadType) => {
        const loadScriptSectionData = async (sectionID) => {
            const response = await fetchWithDefaults(`/dynamicScripts/GetScriptSection?sectionID=${sectionID}`)
            const scriptSectionData = await response.json()

            for (let index = 0; index < scriptSectionData.length; index++) {
                const {content, contentType, scriptContentBlockID, scriptSectionID, sectionContentBlockID, position, activeScriptSection, activeScriptContentBlock, activeSectionContentBlock} = scriptSectionData[index];

                sectionData[scriptSectionID].active = !!activeScriptSection
                sectionData[scriptSectionID].contentBlocks.push({
                    blockID: scriptContentBlockID,
                    position,
                    active: !!activeSectionContentBlock, // is the association between this section and content block active
                    sectionContentBlockID,
                })

                contentBlockData[scriptContentBlockID] = {
                    content,
                    active: !!activeScriptContentBlock, // the current content block active
                    contentType
                }
            }
        }

        const response = await fetchWithDefaults(`/dynamicScripts/GetSectionsForTenantLeadType?leadType=${leadType}`)
        const scriptSectionData = await response.json()

        const sectionIDs = []

        const sectionRequest = []

        const sectionData = {}
        const contentBlockData = {}

        for (let index = 0; index < scriptSectionData.sections.length; index++) {
            const {scriptSectionID, sectionName, position, active, sectionLeadTypeID} = scriptSectionData.sections[index];
            sectionData[scriptSectionID] = {
                position,
                sectionLeadTypeID,
                activeInScript: !!active,
                sectionName: sectionName,
                contentBlocks: []
            }

            sectionRequest.push(loadScriptSectionData(scriptSectionID))
            sectionIDs.push(scriptSectionID)
        }

        await Promise.all(sectionRequest)

        setScriptSections(sectionData)
        setScriptContentBlocks(contentBlockData)
        setScriptSectionIDs(sectionIDs)
    }

    const toggleSectionEdit = (sectionID) => {
        const updatedSectionEdit = {...editSection}

        if(!updatedSectionEdit[sectionID]){
            updatedSectionEdit[sectionID] = true
        } else {
            updatedSectionEdit[sectionID] = !updatedSectionEdit[sectionID]
        }

        setEditSection(updatedSectionEdit)
    }

    const toggleSectionContentBlockEdit = (contentBlockID) => {
        const updatedSectionContentBlockEdit = {...editSectionContentBlock}

        if(!updatedSectionContentBlockEdit[contentBlockID]){
            updatedSectionContentBlockEdit[contentBlockID] = true
        } else {
            updatedSectionContentBlockEdit[contentBlockID] = !updatedSectionContentBlockEdit[contentBlockID]
        }

        setEditSectionContentBlock(updatedSectionContentBlockEdit)
    }

    useEffect(()=>{
        if(selectedLeadType){
            getSectionsForTenantLeadType(selectedLeadType)
        }
    }, [selectedLeadType])

    const handleUpdatedConentBlocks = (sectionID,blockID, field, value, index) => {
        const newContentBlockData = {...updatedContentBlockData}

        newContentBlockData[blockID] = {
            ...newContentBlockData[blockID],
            [field]: value
        }

        const sc = {...scriptSections}
        sc[sectionID].contentBlocks[index][field] = value

        setScriptSections(sc)
        setUpdatedContentBlockData(newContentBlockData)

        if(field === 'content'){
            const cb = {...scriptContentBlocks}
            cb[blockID].content = value

            setScriptContentBlocks(cb)
        }
    }

    const saveContentBlockUpdates = async (sectionID, blockID, sectionContentBlockID) => {
        setLoading(true)
        if(updatedContentBlockData[blockID] && updatedContentBlockData[blockID].content){
            // update the content block
            try {
                await fetchWithDefaults(`/dynamicScripts/UpdateScriptContentBlock`, {
                    method: 'PUT',
                    body: JSON.stringify({
                        blockID,
                        content: updatedContentBlockData[blockID].content,
                        contentType: scriptContentBlocks[blockID].contentType,
                        active: scriptContentBlocks[blockID].active,
                    }),
                })
            } catch (error) {
                console.error(error)
            }
        }

        if(updatedContentBlockData[blockID] && (updatedContentBlockData[blockID].position || updatedContentBlockData[blockID].active)){
            // update the script-section/content-block association
            try {
                await fetchWithDefaults(`/dynamicScripts/UpdateScriptSectionContentBlocks`, {
                    method: 'PUT',
                    body: JSON.stringify({
                        sectionBlockID: sectionContentBlockID,
                        position: updatedContentBlockData[blockID].position ?? scriptContentBlocks[blockID].position,
                        active:  updatedContentBlockData[blockID].active ?? scriptContentBlocks[blockID].active,
                    }),
                })
            } catch (error) {
                console.error(error)
            }
        }

        await getSectionsForTenantLeadType(selectedLeadType)
        setLoading(false)
    }

    const saveNewContentToSection = async () => {
        setLoading(true)

        let optionID

        try {
            if(newContentBlockContentType === 'TEXTINPUT' && newContentBlockContentOption){
                const variableInfo = variables.find( variable => variable.id === newContentBlockContentOption)
                const response = await fetchWithDefaults(`/dynamicScripts/AddScriptContentOptions`, {
                    method: 'POST',
                    body: JSON.stringify({
                        optionName: variableInfo.name,
                        optionValue: variableInfo.code.replace(/\{|\}/g, ""),
                        fieldName: 'lead',
                        placeholder:  variableInfo.name
                    }),
                })

                const json_data = await response.json()
                optionID = json_data.id
            } else if (newContentBlockContentType === 'TEXTINPUT' && !newContentBlockContentOption) {
                return
            }

            const response = await fetchWithDefaults(`/dynamicScripts/AddScriptContentBlock`, {
                method: 'POST',
                body: JSON.stringify({
                    content: newContentBlockContent,
                    contentType: newContentBlockContentType
                }),
            })

            const json_data = await response.json()

            if(json_data.id){
                if(optionID){
                    await fetchWithDefaults(`/dynamicScripts/AddScriptContentBlockOptions`, {
                        method: 'POST',
                        body: JSON.stringify({
                            blockID: json_data.id,
                            optionIDs: [optionID],
                        }),
                    })
                }

                await fetchWithDefaults(`/dynamicScripts/AddScriptSectionContentBlocks`, {
                    method: 'POST',
                    body: JSON.stringify({
                        scriptContentBlockID: json_data.id,
                        scriptSectionID: addContentBlockSectionID,
                        position: scriptSections[addContentBlockSectionID].contentBlocks.length + 1
                    }),
                })

                await getSectionsForTenantLeadType(selectedLeadType)
            }

            setAddNewContentBlockSectionID(null)
            setNewContentBlockContentType(null)
            setNewContentBlockContent(null)
            setNewContentBlockContentOption(null)
        } catch (error) {
            console.error(error)
        }

        setLoading(false)
    }

    const saveNewSection = async () =>{
        setLoading(true)

        try {
            const response = await fetchWithDefaults(`/dynamicScripts/AddScriptSection`, {
                method: 'POST',
                body: JSON.stringify({
                    sectionName: newSectionName,
                }),
            })

            const json_data = await response.json()

            if(json_data.id){
                await fetchWithDefaults(`/dynamicScripts/AddScriptSectionLeadTypeTenants`, {
                    method: 'POST',
                    body: JSON.stringify({
                        scriptSectionID: json_data.id,
                        leadType: selectedLeadType,
                        position: scriptSectionIDs.length + 1
                    }),
                })
            }

            await getSectionsForTenantLeadType(selectedLeadType)
            setAddNewSection(false)
            setNewSectionName(null)
        } catch (error) {
            console.error(error)
        }

        setLoading(false)
    }

    const saveSectionUpdates = async (sectionID) => {
            try {
                await fetchWithDefaults(`/dynamicScripts/UpdateScriptSection`, {
                    method: 'PUT',
                    body: JSON.stringify({
                        sectionID,
                        active: scriptSections[sectionID].active,
                        sectionName: updatedScriptSection
                    }),
                })

                setUpdatedScriptSection(null)
                toggleSectionEdit(sectionID)

                if(excludeSectionID === sectionID){
                    await fetchWithDefaults(`/dynamicScripts/UpdateScriptSectionLeadTypeTenants`, {
                        method: 'PUT',
                        body: JSON.stringify({
                            sectionLeadTypeID: scriptSections[sectionID].sectionLeadTypeID,
                            position: scriptSections[sectionID].position,
                            active: scriptSections[sectionID].activeInScript,
                        }),
                    })

                    setExcludeSectionID(null)
                }

                await getSectionsForTenantLeadType(selectedLeadType)
            } catch (error) {
                console.error(error)
            }
    }

    const handleScriptSectionActiveToggle = (sectionID, active) => {
        const updatedSections = {...scriptSections}
        setExcludeSectionID(sectionID)
        updatedSections[sectionID].activeInScript = !!active
        console.log('here',{sectionID, active, updatedSections})
        setScriptSections(updatedSections)
    }

    useEffect(()=>{
        if(!addContentBlockSectionID){
            setNewContentBlockContentType(null)
            setNewContentBlockContent(null)
        }
    }, [addContentBlockSectionID])

    const variables = useSelector((state) => state.variables.variables)
    return (
        <>
            {selectedLeadType ? (
                <>
                    {addContentBlockSectionID && (
                        <div style={{ width: '625px', position: 'relative', background: 'white', zIndex: '2', padding: '16px 10px', boxShadow:' 1px 1px 1px darkgray', margin: 'auto' }}>
                            <div style={{ width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '16px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                                <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', gap: 16, display: 'inline-flex' }}>
                                    <div style={{ color: 'black', fontSize: 26, fontFamily: 'Montserrat', fontWeight: '700', letterSpacing: 0.10, wordWrap: 'break-word' }}>Add Content To Section</div>
                                    <div onClick={() => setAddNewContentBlockSectionID(false)}><Icon name={'x-close-q'} color='#707070' size={16} adjust="fontello" /></div>
                                </div>
                                {!newContentBlockContentType ? (
                                    <div style={{ width: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                                        <Dropdown
                                            inputLabel='Select the type of content to add'
                                            inputValue={newContentBlockContentType}
                                            options={[{label:'Text', value: 'TEXT'}, {label: 'Text Box', value: 'TEXTINPUT'}]}
                                            changeHandler={e => setNewContentBlockContentType(e.target.value)}
                                        />
                                    </div>
                                ) : (
                                    <>
                                        {newContentBlockContentType === 'TEXTINPUT' ? (
                                            <div style={{width: '100%'}}>
                                                <Dropdown
                                                    inputLabel='Select a variable for this field.'
                                                    inputValue={newContentBlockContentOption}
                                                    options={variables.filter(variable => variable.type === 'lead').map(variable => ({
                                                        label: variable.name,
                                                        value: variable.id
                                                    }))}
                                                    changeHandler={e => setNewContentBlockContentOption(e.target.value)}
                                                    customStyles={{height: null}}
                                                    disabled={loading}
                                                />
                                                <InputTextField
                                                    inputLabel='Enter the content.'
                                                    inputValue=""
                                                    changeHandler={e => setNewContentBlockContent(e.target.value)}
                                                    disabled={loading}
                                                />
                                            </div>

                                        ) : (
                                            <div style={{width: '100%'}}>
                                                <InputTextField
                                                    inputLabel='Enter the content.'
                                                    inputValue=""
                                                    changeHandler={e => setNewContentBlockContent(e.target.value)}
                                                    disabled={loading}
                                                />
                                            </div>
                                        )}

                                        <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex', height: 'fit-content' }}>
                                            <PrimaryButton
                                                buttonLabel='Cancel'
                                                clickHandler={_ => setNewContentBlockContent(null)}
                                                disabled={loading}
                                                buttonClass='q-destructive-button'
                                            />

                                            <PrimaryButton
                                                buttonLabel='Add Content'
                                                clickHandler={_ => saveNewContentToSection()}
                                                disabled={loading}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}

                    {addNewSection && (
                        <div style={{ width: '625px', position: 'relative', background: 'white', zIndex: '2', padding: '16px 10px', boxShadow:' 1px 1px 1px darkgray', margin: 'auto' }}>
                            <div style={{ width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '16px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                                <div style={{ width: '100%', alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', gap: 16, display: 'inline-flex' }}>
                                    <div style={{ color: 'black', fontSize: 26, fontFamily: 'Montserrat', fontWeight: '700', letterSpacing: 0.10, wordWrap: 'break-word' }}>Add New Section</div>
                                    <div onClick={() => setAddNewSection(false)}><Icon name={'x-close-q'} color='#707070' size={16} adjust="fontello" /></div>
                                </div>
                                <div style={{width: '100%'}}>
                                    <InputTextField
                                        inputLabel='Enter the section name.'
                                        inputValue=""
                                        changeHandler={e => setNewSectionName(e.target.value)}
                                        disabled={loading}
                                    />
                                </div>
                                <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex', height: 'fit-content' }}>
                                    <PrimaryButton
                                        buttonLabel='Add Section'
                                        clickHandler={_ => saveNewSection()}
                                        disabled={loading}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <div className='outerWrapper' style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ width: '100%', margin: '20px auto 85px', maxWidth: '1500px' }}>
                            <div style={{ width: '100%', paddingLeft: 24, paddingRight: 24, paddingTop: 16, paddingBottom: 16, background: '#F1F1F1', borderBottom: '2px #F1F1F1 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 40, display: 'inline-flex', borderRadius: '5px 5px 0px 0px', }}>
                                <div style={{ flex: '1 1 0', color: '#2F2F2F', fontSize: 20, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word' }}>{scriptSectionIDs.length > 0 ? 'Edit the' : 'Add a New'} {selectedLeadType} script</div>
                                <div style={{ justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'flex' }} />
                            </div>
                            {scriptSectionIDs.map((sectionID, _) => (
                                <>
                                    <div key={`section_${sectionID}`} style={{ width: '100%', height: '100%', padding: 24, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex', background: 'white', borderRadius: ' 0px 0px 5px 5px', }}>
                                        <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 40, display: 'flex' }}>
                                            <div style={{ width: '100%', color: '#2F2F2F', fontSize: 18, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word' }}>
                                                {editSection[sectionID] ? (
                                                    <div style={{display: 'inline-flex', flexDirection:'column', width: '100%', alignItems:'center'}}>
                                                        <InputTextField
                                                            inputLabel='Edit Section Name'
                                                            inputValue={scriptSections[sectionID].sectionName}
                                                            changeHandler={e => setUpdatedScriptSection(e.target.value)}
                                                            disabled={loading}
                                                        />
                                                        <div style={{ justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex', height: 'fit-content', gap: '8px' }}>
                                                            <PrimaryButton
                                                                buttonLabel={`${scriptSections[sectionID].activeInScript ? 'Exclude from' : 'Include in'} the script`}
                                                                clickHandler={_ => handleScriptSectionActiveToggle(sectionID, !scriptSections[sectionID].activeInScript)}
                                                                disabled={loading}
                                                                buttonClass={`${scriptSections[sectionID].activeInScript ? 'q-destructive-button' : 'q-primary-button' }`}
                                                            />
                                                            <PrimaryButton
                                                                buttonLabel='Save Changes'
                                                                clickHandler={_ => saveSectionUpdates(sectionID)}
                                                                disabled={loading}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>{scriptSections[sectionID].sectionName}</div>
                                                )}
                                            </div>
                                            <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'flex' }}>
                                                <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex', height: 'fit-content' }}>
                                                    <PrimaryButton
                                                        buttonLabel='Edit Section'
                                                        clickHandler={_ => toggleSectionEdit(sectionID)}
                                                        disabled={loading}
                                                    />

                                                    <PrimaryButton
                                                        buttonLabel='Add Content'
                                                        clickHandler={_ => setAddNewContentBlockSectionID(sectionID)}
                                                        disabled={loading}
                                                    />
                                                </div>
                                                {scriptSections[sectionID].contentBlocks.map(({blockID, position, active, sectionContentBlockID}, index) => (
                                                    <>
                                                        <div key={`content_block_${sectionID}_${blockID}`} style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'flex' }}>
                                                            <div style={{ alignSelf: 'stretch', background: 'white', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-end', gap: 20, display: 'inline-flex' }}>
                                                                <>
                                                                    {editSectionContentBlock[blockID] ? (
                                                                        <>
                                                                            <Variables
                                                                                data={variables}
                                                                                appendVariable={v => handleUpdatedConentBlocks(sectionID, blockID, 'content', `${scriptContentBlocks[blockID].content} ${v}`, index) }
                                                                            />
                                                                            <InputTextField
                                                                                inputLabel='Edit Text'
                                                                                inputValue={scriptContentBlocks[blockID].content}
                                                                                changeHandler={e => handleUpdatedConentBlocks(sectionID,blockID, 'content', e.target.value, index)}
                                                                                disabled={loading}
                                                                            />
                                                                            <InputTextField
                                                                                inputLabel='Change Section Position'
                                                                                inputValue={position}
                                                                                changeHandler={e => handleUpdatedConentBlocks(sectionID,blockID, 'position', parseInt(e.target.value), index)}
                                                                                disabled={loading}
                                                                            />
                                                                            <Toggle
                                                                                toggleText='Exclude from content from section'
                                                                                toggleOn={active}
                                                                                toggleHandler={_ => handleUpdatedConentBlocks(sectionID,blockID, 'active', !active, index)}
                                                                                disabled={loading}
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <div>{scriptContentBlocks[blockID].content}</div>
                                                                    )}
                                                                </>
                                                            </div>
                                                        </div>
                                                        <div key={`content_block_buttons_${sectionID}_${blockID}`} style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'flex' }}>
                                                            <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex', height: 'fit-content' }}>
                                                                <PrimaryButton
                                                                    buttonLabel='Edit Content'
                                                                    clickHandler={_ => toggleSectionContentBlockEdit(blockID)}
                                                                    disabled={loading}
                                                                />

                                                                <PrimaryButton
                                                                    buttonLabel='Save Changes'
                                                                    clickHandler={_ => saveContentBlockUpdates(sectionID, blockID,sectionContentBlockID)}
                                                                    disabled={loading}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                </>
                            ))}

                            <div style={{ width: '100%', height: '100%', padding: 24, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex', background: 'white', borderRadius: ' 0px 0px 5px 5px', }}>
                                <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'flex' }}>
                                    <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex', height: 'fit-content' }}>
                                        <PrimaryButton
                                            buttonLabel='Add New Section'
                                            disabled={loading}
                                            clickHandler={_ => setAddNewSection(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (

                <div style={{ width: '625px', position: 'relative', background: 'white', zIndex: '2', padding: '16px 10px', boxShadow: ' 1px 1px 1px darkgray', margin: 'auto' }}>
                    <div style={{ width: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
                        <Dropdown
                            inputLabel='Select a lead type'
                            inputValue={selectedLeadType}
                            options={leadTypeList}
                            changeHandler={e => setSelectedLeadType(e.target.value)}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default LeadTypeScriptTemplate